import { ServiceBase } from '../../../core/services/ServiceBase'
import proxy from './Proxy'

class Service extends ServiceBase {
  getNewsType(params) {
    return this.getData(() => proxy.getNewsType(params))
  }
  getSentiments(params) {
    return this.getData(() => proxy.getSentiments(params))
  }
}

const service = new Service()
export default service
